import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { TicketPass } from "@/components/TicketPass";

export default function DownloadTicket() {
  const [firstName, setFirstName] = useState("");
  const [mobile, setMobile] = useState("");
  const [bookings, setBookings] = useState(null);
  const [loading, setLoading] = useState(false);

  const search = async (e) => {
    e.preventDefault();
    if (!firstName.trim() || !mobile.trim()) { toast.error("Enter name and mobile"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/bookings/lookup", { first_name: firstName, mobile });
      setBookings(data);
      if (!data.length) toast.info("No tickets found for these details");
    } catch { toast.error("Lookup failed"); }
    setLoading(false);
  };

  return (
    <div data-testid="download-ticket-page">
      <PageHeader caption="Your Tickets" title="Download Ticket" subtitle="Enter your details to find and download your tickets." />
      <div className="mx-auto max-w-3xl px-4 pb-10 sm:px-8">
        <form onSubmit={search} className="card-dark p-6 sm:p-8" data-testid="lookup-form">
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <label className="caption mb-2 block">First Name</label>
              <input className="input-field" value={firstName} onChange={(e) => setFirstName(e.target.value)} data-testid="lookup-name-input" />
            </div>
            <div>
              <label className="caption mb-2 block">Mobile Number</label>
              <input className="input-field" value={mobile} onChange={(e) => setMobile(e.target.value)} inputMode="numeric" data-testid="lookup-phone-input" />
            </div>
          </div>
          <button type="submit" disabled={loading} className="btn-gold mt-5 w-full" data-testid="lookup-submit">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "FIND MY TICKETS"}
          </button>
        </form>

        {bookings !== null && (
          <div className="mt-8 space-y-6" data-testid="lookup-results">
            {bookings.length === 0 ? (
              <p className="text-center text-sm text-zinc-500">No tickets found. Check your name and number.</p>
            ) : bookings.map((b) => <TicketPass key={b.booking_id} booking={b} />)}
          </div>
        )}
      </div>
    </div>
  );
}
